module.exports = __webpack_public_path__ + "img/logo.50a0c8f4.png";